import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { RadioQuestionModel } from '../../../viewmodels/policy-item.model';
import { MetersCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'meters-policy',
  templateUrl: './meters.component.html',
})
export class MetersComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = MetersCopy;

  haveMeters = new RadioQuestionModel();
  cancelUphold = new RadioQuestionModel();
  meterMethod = new RadioQuestionModel();
  faultyMeterPolicy = new RadioQuestionModel();
  acceptFaultyMeter = new RadioQuestionModel();
  refund = new RadioQuestionModel();

  complaintDays = '';
  faultyMeter = '';
  fewDays = '';
  safeguard = '';

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setHaveMetersQuestion();
    this.setCancelUpholdQuestion();
    this.setMeterMethodQuestion();
    this.setFaultyMeterPolicyQuestion();
    this.setAcceptFaultyMeterQuestion();
    this.setRefundQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setHaveMetersQuestion() {
    this.haveMeters.data = {
      title: this.textCopy.haveMetersTitle,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onHaveMetersSelected(answerValue) {
    this.haveMeters.valueSelected = answerValue;
  }

  setCancelUpholdQuestion() {
    this.cancelUphold.data = {
      title: this.textCopy.cancelUpholdTitle,
      includeTitle: true,
      beforeText: this.textCopy.cancelUpholdBeforeSubtitle,
      afterText: this.textCopy.cancelUpholdAfterSubtitle,
      answers: [
        {
          text: "always uphold the PCN as he shouldn't have parked on an expired meter, even if it was faulty",
          value: '0',
        },
        { text: 'cancel the PCN if:', value: '1' },
      ],
    };
  }
  onCancelUpholdSelected(answerValue) {
    this.cancelUphold.valueSelected = answerValue;
  }

  setMeterMethodQuestion() {
    this.meterMethod.data = {
      title: this.textCopy.meterMethodTitle,
      includeTitle: true,
      beforeText: this.textCopy.meterMethodSubtitle,
      answers: [
        {
          text: "check records. If inconclusive, organise a site check of the meter if the driver's complaint arrived promptly.",
          value: '0',
        },
        { text: 'check records only', value: '1' },
        { text: 'none of the above', value: '2' },
      ],
    };
  }
  onMeterMethodSelected(answerValue) {
    this.meterMethod.valueSelected = answerValue;
  }

  setFaultyMeterPolicyQuestion() {
    this.faultyMeterPolicy.data = {
      title: this.textCopy.faultyMeterPolicyTitle,
      answers: [
        { text: "ignore other drivers' complaints", value: '0' },
        {
          text: `accept that the meter was faulty if both drivers (the driver whose letter we're answering and the driver
            whose complaint is on record) had problems with the meter within a few days of each other`,
          value: '1',
        },
      ],
    };
  }
  onFaultyMeterPolicySelected(answerValue) {
    this.faultyMeterPolicy.valueSelected = answerValue;
  }

  setAcceptFaultyMeterQuestion() {
    this.acceptFaultyMeter.data = {
      title: this.textCopy.acceptFaultyMeterTitle,
      answers: [
        { text: 'yes', value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }
  onAcceptFaultyMeterSelected(answerValue) {
    this.acceptFaultyMeter.valueSelected = answerValue;
  }

  setRefundQuestion() {
    this.refund.data = {
      title: this.textCopy.refundTitle,
      includeTitle: true,
      beforeText: this.textCopy.refundSubtitle,
      answers: [
        { text: 'state the amount of money lost', value: '0' },
        { text: `state the amount of money lost and request a refund`, value: '1' },
      ],
    };
  }
  onRefundSelected(answerValue) {
    this.refund.valueSelected = answerValue;
  }

  setSelectedValues() {
    this.haveMeters.valueSelected = this.policiesAnswers['15_1'];
    this.cancelUphold.valueSelected = this.policiesAnswers['15_2'];
    this.meterMethod.valueSelected = this.policiesAnswers['15_3'];
    this.complaintDays = this.policiesAnswers['15_3_1_1_1'];
    this.faultyMeter = this.policiesAnswers['15_4_1'];
    this.faultyMeterPolicy.valueSelected = this.policiesAnswers['15_4_2'];
    this.fewDays = this.policiesAnswers['15_4_2_1'];
    this.acceptFaultyMeter.valueSelected = this.policiesAnswers['15_4_3'];
    this.refund.valueSelected = this.policiesAnswers['15_5'];
    this.safeguard = this.policiesAnswers['15_5_1'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '15_1', description: this.haveMeters.valueSelected },
      { id: '15_2', description: this.cancelUphold.valueSelected },
      { id: '15_3', description: this.meterMethod.valueSelected },
      { id: '15_3_1_1_1', description: this.complaintDays },
      { id: '15_4_1', description: this.faultyMeter },
      { id: '15_4_2', description: this.faultyMeterPolicy.valueSelected },
      { id: '15_4_2_1', description: this.fewDays },
      { id: '15_4_3', description: this.acceptFaultyMeter.valueSelected },
      { id: '15_5', description: this.refund.valueSelected },
      { id: '15_5_1', description: this.safeguard },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
